/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import {CorsAnywhere} from "../CorsAnywhere";
import React from 'react'

/* global WorldWind */

export default class EcmwfSurfaceNO2 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Surface NO2",
            service: CorsAnywhere + "http://apps.ecmwf.int/wms/&token=public",
            version: "1.3.0",
            layerNames: "composition_no2_surface",
        };

        super(cfg);

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© ECMWF",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>Nitrogen dioxide is present both in troposphere and stratosphere. NO<sub>2</sub> enters earth atmosphere
                due to human anthropogenic activities such as fossil fuel combustion (oil, gas, coal) biomass burning
                and road traffic. In cities, 80% of NO<sub>2</sub> comes from traffic and fossil fuels. Also, it enters
                atmosphere in a natural was which is a result of microbiological processes in soil, wildfires and
                lightnings.</p>
            <p><a href="http://www.tropomi.eu/data-products/nitrogen-dioxide" target="_blank" rel="noopener noreferrer">Read
                more
                here.</a></p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://apps.ecmwf.int/wms/?token=public&request=GetLegend&layers=composition_no2_surface&styles=sh_nipy_spectral_ch4_surface&width=350&height=50"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                ppbv (parts per billion by volume)
            </p>
        </div>);
    }
}
